// Not an env var: the same support line answers every environment, like the legal links in `legal.ts`.
export const SUPPORT_WHATSAPP_NUMBER = "573006607857";
export const SUPPORT_WHATSAPP_DISPLAY = "+57 300 660 7857";

export function supportWhatsAppUrl(message: string): string {
  return `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
